/**
 * Created by shobhitjain on 02/01/20.
 */

import React from 'react';
import style from './CustomerProfileTable.scss';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import row from '../../../../assets/row-flag.jpg';
import ReactCountryFlag from 'react-country-flag';
import moment from 'moment';
import {
  getCustomerType,
  getRiskRatingColor
} from '../../../../components/TableHeader/tableRowUtils';
import { checkIfBoolean, isEmptyNullUndef } from '../../../../services/util';

import { isEmpty, orderBy } from '../../../../util/lodashlike';
const getGender = (gender) => {
  if (!isEmptyNullUndef(gender)) {
    if (gender.toLowerCase() === 'm' || gender.toLowerCase() === 'male') {
      return 'Male';
    }
    if (gender.toLowerCase() === 'f' || gender.toLowerCase() === 'female') {
      return 'Female';
    }
    return '-';
  }
  return '-';
};

const getItemValue = (itemName, customerProfile) => {
  let itemValue = null;
  switch (itemName) {
    case 'primaryPartyKey':
      itemValue = customerProfile['customer_id'];
      break;
    case 'partyName':
      itemValue = customerProfile['customer_name'];
      break;
    case 'riskRating':
      itemValue = customerProfile['risk_rating'];
      break;
    case 'customerType':
      itemValue = customerProfile['type'];
      break;
    case 'dobOrIncorporationDate':
      itemValue = customerProfile['dob'];
      break;
    case 'nationality':
      itemValue = customerProfile['citizenship'];
      break;

    case 'domicileCountry':
      itemValue = customerProfile['domicile_country'];
      break;
    case 'postalCode':
      itemValue = customerProfile['postal_code'];
      break;
    case 'residentialAddress':
      itemValue = customerProfile['residential_address'];
      break;

    case 'highRiskPartyInfo':
      itemValue = customerProfile['high_risk_party_info'];
      break;
    case 'employerTypeOfBusiness':
      itemValue = customerProfile['employer_typeof_business'];
      break;
    case 'alertId':
      itemValue = customerProfile['alert_id'];
      break;

    case 'documentType':
      itemValue = customerProfile['document_type'];
      break;
    case 'nationalityCode':
      itemValue = customerProfile['nationality_code'];
      break;
    case 'contactNumber':
      itemValue = customerProfile['contact_number'];
      break;

    case 'isPrimary':
      itemValue = customerProfile['is_primary'];
      break;
    case 'documentId':
      itemValue = customerProfile['document_id'];
      break;
    case 'documentIssueCountry':
      itemValue = customerProfile['document_issue_country'];
      break;

    case 'employerName':
      itemValue = customerProfile['employer_name'];
      break;
    case 'annualTurnover':
      itemValue = customerProfile['annual_turnover'];
      break;
    case 'partyKey':
      itemValue = customerProfile['party_key'];
      break;
    case 'citizenshipCountry':
      itemValue = customerProfile['citizenship_country'];
      break;
    default:
      itemValue = customerProfile[itemName];
      break;
  }

  return itemValue;
};

/*
 *  CustomerProfileTable for showing Customer Profile
 *  @param customerProfile {object}
 * */
/**
 * Customer Profile for INDIVIDUAL customer
 * @param customerProfile
 * @returns {*}
 * @constructor
 */
const CustomerProfileBodyIndividual = ({ customerProfile }) => {
  const {
    customer_id = '-',
    age = '-',
    gender = '-',
    isStaff = '',
    city = '-',
    segment = '-',
    division = '-',
    activityDetailsTxnAdditionalInfo = '-',
    activityDetailsTxnByType = '-',
    product = '-',
    current_alert_account_id = '-',
    customer_name = '-',
    risk_rating = '-',
    type = '-',
    dob = '-',
    citizenship = '-',
    domicile_country = '-',
    occupation = '-',
    ns_link = '-',
    postal_code = '-',
    residential_address = '-',
    str_count = '-',
    alert_count = '-',
    isPep = '',
    high_risk_party_info = '',
    employer_typeof_business = '-',
    alert_id = '-',
    document_type = '-',
    nationality_code = '',
    birthIncorporationCountry = '-',
    contact_number = '-',
    is_primary = '-',
    document_id = '-',
    document_issue_country = '',
    employer_name = '-',
    annual_turnover = '-',
    party_key = '-',
    esidenceOperationCountry = '-',
    citizenship_country = '-',
    designation = '-'
  } = customerProfile || {};

  let expiration_date = '-';
  let predefined_comments = '-';

  try {
    const hRPInfoJson = JSON.parse(high_risk_party_info);
    if (!isEmpty(hRPInfoJson)) {
      expiration_date =
        hRPInfoJson.expiration_date && hRPInfoJson.expiration_date !== 'null'
          ? moment
              .utc(hRPInfoJson.expiration_date, [
                'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
              ])
              .local()
              .format('YYYY/MM/DD')
          : '-';
      predefined_comments =
        hRPInfoJson.predefined_comments &&
        hRPInfoJson.predefined_comments !== 'null'
          ? hRPInfoJson.predefined_comments
          : '-';
    }
  } catch (err) {}

  let flag =
    nationality_code === 'RoW' ||
    nationality_code === '' ||
    nationality_code === 'not_available' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={nationality_code}
        svg
      />
    );
  let dicFlag =
    document_issue_country === 'RoW' || document_issue_country === '' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={document_issue_country}
        svg
      />
    );
  const riskRating = getRiskRatingColor(risk_rating);
  const isStaffIndicator = checkIfBoolean(isStaff, true, 'Yes', 'No');
  const isPepOrPEC = checkIfBoolean(isPep, true, 'Yes', 'No');
  return (
    <div className="card-body details-section">
      <div className="row">
        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>Customer ID</label>
            <p title={customer_id}>{customer_id}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Customer Name</label>
            <p title={customer_name}>{customer_name}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Customer Type</label>
            <p title={getCustomerType(type)}>{getCustomerType(type)}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Segment</label>
            <p title={segment}>{segment}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Division</label>
            <p title={division}>{division}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Type of Business</label>
            <p title={employer_typeof_business}>{employer_typeof_business}</p>
          </div>
        </div>

        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>Age</label>
            <p title={age}>{age}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Date of Birth</label>
            <p title={dob}>{dob}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Registered Address</label>
            <p title={residential_address}>{residential_address}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Postal Code</label>
            <p title={postal_code}>{postal_code}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Contact Number</label>
            <p style={{ wordBreak: 'break-all' }} title={contact_number}>
              {contact_number}
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Designation</label>
            <p title={designation}>{designation}</p>
          </div>
        </div>

        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>Gender</label>
            <p title={getGender(gender)}>{getGender(gender)}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Nationality</label>
            <p title={citizenship_country}>{citizenship_country}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>ID Number</label>
            <p title={document_id}>{document_id}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>ID Type</label>
            <p title={document_type}>{document_type}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>ID Country</label>
            <p title={document_issue_country}>
              {document_issue_country !== '' ? document_issue_country : '-'}
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Employer Name</label>
            <p title={employer_name}>{employer_name}</p>
          </div>
        </div>

        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>PEP/PEC</label>
            <p title={isPepOrPEC}>{isPepOrPEC}</p>
          </div>

          <div className={style.label_value_wrapper}>
            <label>Risk Rating</label>
            <p title={risk_rating}>
              <span className={classnames(style.risk_status, riskRating.style)}>
                {riskRating.label}
              </span>
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label
              style={{ flexBasis: '100%', fontSize: 14, marginBottom: 15 }}>
              High Risk Party Information
            </label>
          </div>

          <div className={style.label_value_wrapper}>
            <label className="pl-2">- Expiration Date</label>
            <p title={expiration_date}>
              {expiration_date === 'null' ? '-' : expiration_date}
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label className="pl-2">- Predefined Comments</label>
            <p title={predefined_comments}>
              {predefined_comments === 'null' ? '-' : predefined_comments}
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Staff Indicator</label>
            <p title={isStaffIndicator}>{isStaffIndicator}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

/*
 *  CustomerProfileTable for showing Customer Profile with settings
 *  @param customerProfile {object}
 *  @param settings {array}
 * */
/**
 * Customer Profile for INDIVIDUAL customer with settings
 * @param customerProfile
 * @param settings
 * @returns {*}
 * @constructor
 */
const CustomerProfileBodyIndividualWithSettings = ({
  customerProfile,
  settings
}) => {
  if (Array.isArray(settings) && settings.length > 0) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']);
    return (
      <div className="card-body details-section">
        <div className="row">
          {sortedSettings.map((currentColumn, currentColumnIndex) => {
            if (currentColumn.columnVisibility) {
              const { columnDetail } = currentColumn;

              return (
                <div key={`column-${currentColumnIndex}`} className="col-sm-3">
                  {columnDetail.map((currentItem, currentItemIndex) => {
                    if (currentItem.visibility) {
                      return getCustomerProfileIndividualItem(
                        currentItem,
                        customerProfile
                      );
                    }

                    return null;
                  })}
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>
    );
  }

  return null;
};

/*
 *  Renderer for Customer Profile for INDIVIDUAL customer
 *  @param columnItem {itemName, itemLabel}
 *  @param customerProfile {object}
 * */
/**
 * Customer Profile item for INDIVIDUAL customer
 * @param columnItem
 * @param customerProfile
 * @returns {*}
 * @constructor
 */
const getCustomerProfileIndividualItem = (
  { itemName, itemLabel },
  customerProfile
) => {
  const {
    customer_id = '-',
    age = '-',
    gender = '-',
    isStaff = '',
    city = '-',
    segment = '-',
    division = '-',
    activityDetailsTxnAdditionalInfo = '-',
    activityDetailsTxnByType = '-',
    product = '-',
    current_alert_account_id = '-',
    customer_name = '-',
    risk_rating = '-',
    type = '-',
    dob = '-',
    citizenship = '-',
    domicile_country = '-',
    occupation = '-',
    ns_link = '-',
    postal_code = '-',
    residential_address = '-',
    str_count = '-',
    alert_count = '-',
    isPep = '',
    high_risk_party_info = '',
    employer_typeof_business = '-',
    alert_id = '-',
    document_type = '-',
    nationality_code = '',
    birthIncorporationCountry = '-',
    contact_number = '-',
    is_primary = '-',
    document_id = '-',
    document_issue_country = '',
    employer_name = '-',
    annual_turnover = '-',
    party_key = '-',
    esidenceOperationCountry = '-',
    citizenship_country = '-',
    designation = '-'
  } = customerProfile || {};
  console.log('customerProfile', customerProfile);

  let expiration_date = '-';
  let predefined_comments = '-';

  try {
    const hRPInfoJson = JSON.parse(high_risk_party_info);
    if (!isEmpty(hRPInfoJson)) {
      expiration_date =
        hRPInfoJson.expiration_date && hRPInfoJson.expiration_date !== 'null'
          ? moment
              .utc(hRPInfoJson.expiration_date, [
                'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
              ])
              .local()
              .format('YYYY/MM/DD')
          : '-';
      predefined_comments =
        hRPInfoJson.predefined_comments &&
        hRPInfoJson.predefined_comments !== 'null'
          ? hRPInfoJson.predefined_comments
          : '-';
    }
  } catch (err) {}

  let flag =
    nationality_code === 'RoW' ||
    nationality_code === '' ||
    nationality_code === 'not_available' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={nationality_code}
        svg
      />
    );
  let dicFlag =
    document_issue_country === 'RoW' || document_issue_country === '' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={document_issue_country}
        svg
      />
    );
  const riskRating = getRiskRatingColor(risk_rating);
  const isStaffIndicator = checkIfBoolean(isStaff, true, 'Yes', 'No');
  const isPepOrPEC = checkIfBoolean(isPep, true, 'Yes', 'No');

  const itemValue = getItemValue(itemName, customerProfile);

  if (itemName === 'customerType') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={getCustomerType(type)}>{getCustomerType(type)}</p>
      </div>
    );
  }

  if (itemName === 'contactNumber') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p style={{ wordBreak: 'break-all' }} title={contact_number}>
          {contact_number}
        </p>
      </div>
    );
  }

  if (itemName === 'gender') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={getGender(gender)}>{getGender(gender)}</p>
      </div>
    );
  }

  if (itemName === 'riskRating') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={risk_rating}>
          <span className={classnames(style.risk_status, riskRating.style)}>
            {riskRating.label}
          </span>
        </p>
      </div>
    );
  }

  if (itemName === 'highRiskPartyInfo') {
    return (
      <div>
        <div className={style.label_value_wrapper}>
          <label style={{ flexBasis: '100%', fontSize: 14, marginBottom: 15 }}>
            {itemLabel}
          </label>
        </div>

        <div className={style.label_value_wrapper}>
          <label className="pl-2">- Expiration Date</label>
          <p title={expiration_date}>
            {expiration_date === 'null' ? '-' : expiration_date}
          </p>
        </div>
        <div className={style.label_value_wrapper}>
          <label className="pl-2">- Predefined Comments</label>
          <p title={predefined_comments}>
            {predefined_comments === 'null' ? '-' : predefined_comments}
          </p>
        </div>
      </div>
    );
  }

  if (itemName === 'isStaff') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={isStaffIndicator}>{isStaffIndicator}</p>
      </div>
    );
  }

  if (itemName === 'isPep') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={isPepOrPEC}>{isPepOrPEC}</p>
      </div>
    );
  }

  return (
    <div className={style.label_value_wrapper}>
      <label>{itemLabel}</label>
      <p title={itemValue}>{itemValue}</p>
    </div>
  );
};

/*
 *  Renderer for Customer Profile for CORPORATE customer
 *  @param columnItem {itemName, itemLabel}
 *  @param customerProfile {object}
 * */
/**
 * Customer Profile item for CORPORATE customer
 * @param columnItem
 * @param customerProfile
 * @returns {*}
 * @constructor
 */
const getCustomerProfileCorporateItem = (
  { itemName, itemLabel },
  customerProfile
) => {
  const {
    customer_id = '-',
    age = '-',
    gender = '-',
    isStaff = '',
    city = '-',
    segment = '-',
    division = '-',
    activityDetailsTxnAdditionalInfo = '-',
    activityDetailsTxnByType = '-',
    product = '-',
    current_alert_account_id = '-',
    customer_name = '-',
    risk_rating = '-',
    type = '-',
    dob = '-',
    citizenship = '-',
    domicile_country = '-',
    occupation = '-',
    ns_link = '-',
    postal_code = '-',
    residential_address = '-',
    str_count = '-',
    alert_count = '-',
    isPep = '',
    birthIncorporationCountry = '-',
    employer_typeof_business = '-',
    alert_id = '-',
    document_type = '-',
    nationality_code = '',
    contact_number = '-',
    is_primary = '-',
    document_id = '-',
    document_issue_country = '',
    high_risk_party_info = '',
    employer_name = '-',
    annual_turnover = '-',
    party_key = '-',
    residenceOperationCountry = '-',
    citizenship_country = '-',
    designation = '-'
  } = customerProfile || {};

  let expiration_date = '-';
  let predefined_comments = '-';

  try {
    const hRPInfoJson = JSON.parse(high_risk_party_info);
    console.log('hRPInfoJson', hRPInfoJson);
    if (!isEmpty(hRPInfoJson)) {
      expiration_date =
        hRPInfoJson.expiration_date && hRPInfoJson.expiration_date !== 'null'
          ? moment
              .utc(hRPInfoJson.expiration_date, [
                'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
              ])
              .local()
              .format('YYYY/MM/DD')
          : '-';
      predefined_comments =
        hRPInfoJson.predefined_comments &&
        hRPInfoJson.predefined_comments !== 'null'
          ? hRPInfoJson.predefined_comments
          : '-';
    }
  } catch (err) {}

  const riskRating = getRiskRatingColor(risk_rating);
  let flag =
    domicile_country === 'RoW' ||
    domicile_country === '' ||
    domicile_country === 'not_available' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={domicile_country}
        svg
      />
    );
  let dicFlag =
    document_issue_country === 'RoW' || document_issue_country === '' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={document_issue_country}
        svg
      />
    );
  const isPePOrPEC = checkIfBoolean(isPep, true, 'Yes', 'No');

  const itemValue = getItemValue(itemName, customerProfile);

  if (itemName === 'customerType') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={getCustomerType(type)}>{getCustomerType(type)}</p>
      </div>
    );
  }

  if (itemName === 'contactNumber') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p style={{ wordBreak: 'break-all' }} title={contact_number}>
          {contact_number}
        </p>
      </div>
    );
  }

  if (itemName === 'gender') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={getGender(gender)}>{getGender(gender)}</p>
      </div>
    );
  }

  if (itemName === 'riskRating') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={risk_rating}>
          <span className={classnames(style.risk_status, riskRating.style)}>
            {riskRating.label}
          </span>
        </p>
      </div>
    );
  }

  if (itemName === 'highRiskPartyInfo') {
    return (
      <div>
        <div className={style.label_value_wrapper}>
          <label style={{ flexBasis: '100%', fontSize: 14, marginBottom: 15 }}>
            {itemLabel}
          </label>
        </div>

        <div className={style.label_value_wrapper}>
          <label className="pl-2">- Expiration Date</label>
          <p title={expiration_date}>
            {expiration_date === 'null' ? '-' : expiration_date}
          </p>
        </div>
        <div className={style.label_value_wrapper}>
          <label className="pl-2">- Predefined Comments</label>
          <p title={predefined_comments}>
            {predefined_comments === 'null' ? '-' : predefined_comments}
          </p>
        </div>
      </div>
    );
  }

  if (itemName === 'isStaff') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={isStaffIndicator}>{isStaffIndicator}</p>
      </div>
    );
  }

  if (itemName === 'isPep') {
    return (
      <div className={style.label_value_wrapper}>
        <label>{itemLabel}</label>
        <p title={isPepOrPEC}>{isPepOrPEC}</p>
      </div>
    );
  }

  return (
    <div className={style.label_value_wrapper}>
      <label>{itemLabel}</label>
      <p title={itemValue}>{itemValue}</p>
    </div>
  );
};

/**
 * Customer Profile for CORPORATE customer
 * @param customerProfile
 * @returns {*}
 * @constructor
 */
const CustomerProfileBodyCorporate = ({ customerProfile }) => {
  const {
    customer_id = '-',
    age = '-',
    gender = '-',
    isStaff = '',
    city = '-',
    segment = '-',
    division = '-',
    activityDetailsTxnAdditionalInfo = '-',
    activityDetailsTxnByType = '-',
    product = '-',
    current_alert_account_id = '-',
    customer_name = '-',
    risk_rating = '-',
    type = '-',
    dob = '-',
    citizenship = '-',
    domicile_country = '-',
    occupation = '-',
    ns_link = '-',
    postal_code = '-',
    residential_address = '-',
    str_count = '-',
    alert_count = '-',
    isPep = '',
    birthIncorporationCountry = '-',
    employer_typeof_business = '-',
    alert_id = '-',
    document_type = '-',
    nationality_code = '',
    contact_number = '-',
    is_primary = '-',
    document_id = '-',
    document_issue_country = '',
    high_risk_party_info = '',
    employer_name = '-',
    annual_turnover = '-',
    party_key = '-',
    residenceOperationCountry = '-',
    citizenship_country = '-',
    designation = '-'
  } = customerProfile || {};

  let expiration_date = '-';
  let predefined_comments = '-';

  try {
    const hRPInfoJson = JSON.parse(high_risk_party_info);
    console.log('!isEmpty(hRPInfoJson', !isEmpty(hRPInfoJson));
    if (!isEmpty(hRPInfoJson)) {
      expiration_date =
        hRPInfoJson.expiration_date && hRPInfoJson.expiration_date !== 'null'
          ? moment
              .utc(hRPInfoJson.expiration_date, [
                'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
              ])
              .local()
              .format('YYYY/MM/DD')
          : '-';
      predefined_comments =
        hRPInfoJson.predefined_comments &&
        hRPInfoJson.predefined_comments !== 'null'
          ? hRPInfoJson.predefined_comments
          : '-';
    }
  } catch (err) {}

  const riskRating = getRiskRatingColor(risk_rating);
  let flag =
    domicile_country === 'RoW' ||
    domicile_country === '' ||
    domicile_country === 'not_available' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={domicile_country}
        svg
      />
    );
  let dicFlag =
    document_issue_country === 'RoW' || document_issue_country === '' ? (
      <img
        src={row}
        style={{ width: '1.333333em', height: '1em', marginRight: 10 }}
      />
    ) : (
      <ReactCountryFlag
        styleProps={{ width: '20px', height: '12px', marginRight: 10 }}
        code={document_issue_country}
        svg
      />
    );
  const isPePOrPEC = checkIfBoolean(isPep, true, 'Yes', 'No');
  return (
    <div className="card-body details-section">
      <div className="row">
        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>Customer ID</label>
            <p title={customer_id}>{customer_id}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Customer Name</label>
            <p title={customer_name}>{customer_name}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Customer Type</label>
            <p title={getCustomerType(type)}>{getCustomerType(type)}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Segment</label>
            <p title={segment}>{segment}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Division</label>
            <p title={division}>{division}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Nature of Business</label>
            <p title={employer_typeof_business}>{employer_typeof_business}</p>
          </div>
        </div>

        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>Country of Operation</label>
            <p title={residenceOperationCountry}>{residenceOperationCountry}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Place of Incorporation</label>
            <p>{birthIncorporationCountry}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Date of Incorporation</label>
            <p title={dob}>{dob}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Registered Address</label>
            <p title={residential_address}>{residential_address}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Postal Code</label>
            <p title={postal_code}>{postal_code}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Contact Number</label>
            <p style={{ wordBreak: 'break-all' }} title={contact_number}>
              {contact_number}
            </p>
          </div>
        </div>

        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>ID Number</label>
            <p title={document_id}>{document_id}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>ID Type</label>
            <p title={document_type}>{document_type}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>ID Country</label>
            <p title={document_issue_country}>
              {document_issue_country !== '' ? document_issue_country : '-'}
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Annual Turnover</label>
            <p title={annual_turnover}>{annual_turnover}</p>
          </div>
        </div>

        <div className="col-sm-3">
          <div className={style.label_value_wrapper}>
            <label>PEP/PEC</label>
            <p title={isPePOrPEC}>{isPePOrPEC}</p>
          </div>
          <div className={style.label_value_wrapper}>
            <label>Risk Rating</label>
            <p title={riskRating.label}>
              <span className={classnames(style.risk_status, riskRating.style)}>
                {riskRating.label}
              </span>
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label
              style={{ flexBasis: '100%', fontSize: 14, marginBottom: 15 }}>
              High Risk Party Information
            </label>
          </div>
          <div className={style.label_value_wrapper}>
            <label className="pl-2">- Expiration Date</label>
            <p title={expiration_date}>
              {expiration_date === 'null' ? '-' : expiration_date}
            </p>
          </div>
          <div className={style.label_value_wrapper}>
            <label className="pl-2">- Predefined Comments</label>
            <p title={predefined_comments}>
              {predefined_comments === 'null' ? '-' : predefined_comments}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

/*
 *  CustomerProfileTable for showing Customer Profile with settings
 *  @param customerProfile {object}
 *  @param settings {array}
 * */
/**
 * Customer Profile for CORPORATE customer with settings
 * @param customerProfile
 * @param settings
 * @returns {*}
 * @constructor
 */
const CustomerProfileBodyCorporateWithSettings = ({
  customerProfile,
  settings
}) => {
  if (Array.isArray(settings) && settings.length > 0) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']);
    return (
      <div className="card-body details-section">
        <div className="row">
          {sortedSettings.map((currentColumn, currentColumnIndex) => {
            if (currentColumn.columnVisibility) {
              const { columnDetail } = currentColumn;

              return (
                <div key={`column-${currentColumnIndex}`} className="col-sm-3">
                  {columnDetail.map((currentItem, currentItemIndex) => {
                    if (currentItem.visibility) {
                      return getCustomerProfileIndividualItem(
                        currentItem,
                        customerProfile
                      );
                    }

                    return null;
                  })}
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>
    );
  }

  return null;
};

/**
 * customerProfile Table component
 * @param customerProfile
 * @param settings
 * @returns {*}
 * @constructor
 */
const CustomerProfileTable = ({ customerProfile }) => {
  const { type = '-' } = customerProfile || {};

  let CustomerProfileBody = null;
  if (type === 'CORPORATE' || type === 'C') {
    CustomerProfileBody = (
      <CustomerProfileBodyCorporate customerProfile={customerProfile} />
    );
  }
  if (type === 'INDIVIDUAL' || type === 'I') {
    CustomerProfileBody = (
      <CustomerProfileBodyIndividual customerProfile={customerProfile} />
    );
  }

  return (
    <div className={classnames(style.card_dark, 'card')}>
      <div className={style.card_header}>Customer Profile</div>
      {CustomerProfileBody}
    </div>
  );
};
/**
 * Proptypes
 * @type {{customerProfile: shim}}
 */
CustomerProfileTable.propTypes = {
  customerProfile: PropTypes.object.isRequired
};

export default CustomerProfileTable;
